import type { Party } from "@/types/ui-models";

/** Compara textos vindos do banco (codigos ou rotulos) sem depender de caixa ou acento. */
export function norm(value: string | null | undefined): string {
  return (value ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/_/g, " ")
    .toLowerCase()
    .trim();
}

export function dash(value: string | null | undefined): string {
  return value && value.trim() !== "" ? value : "—";
}

export function fmtDate(value: string | null | undefined): string {
  if (!value) return "—";
  const d = new Date(value.length <= 10 ? `${value}T00:00:00` : value);
  return Number.isNaN(d.getTime()) ? value : d.toLocaleDateString("pt-BR");
}

/** `role_types` vem agregado do banco (lista separada por virgula). */
export function splitRoles(roles: string | null | undefined): string[] {
  return (roles ?? "")
    .split(",")
    .map((r) => r.trim())
    .filter(Boolean);
}

export function isTechnicalResponsible(party: Party): boolean {
  return splitRoles(party.primaryRole).some((r) => norm(r) === "responsavel tecnico");
}

export function uniqueSorted(values: (string | null | undefined)[]): string[] {
  return Array.from(new Set(values.filter((v): v is string => !!v && v.trim() !== ""))).sort((a, b) =>
    a.localeCompare(b, "pt-BR"),
  );
}
